import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../html/checkbox'
import { Element } from '../../html/element'
import { Icon } from '../../html/icon'
import { TextEllipsisStaticLine } from '../../textEllipsis/TextEllipsisStaticLine'
import { selectChartData, setChartData } from '../store'
import classes from './index.module.scss'

export const LegendItem = ({
  chartId,
  color,
  title,
  isI18n,
  translateProps,
  pieIndex,
  dataKey,
  isCheckbox,
  iconCustom,
  renderCustomIcon,
  setListCheckBox,
  listCheckBox,
  hidden,
  isEllipsis,
  lineClamp,
  isCheckOnClickText,
  isDynamicReport,
}) => {
  const dispatch = useDispatch()
  const activeIndex = useSelector(
    selectChartData(chartId, (data) => data.activeIndex),
  )
  const activeKey = useSelector(
    selectChartData(chartId, (data) => data.activeKey),
  )
  const isActive =
    (isNaN(activeIndex) && !activeKey) ||
    (!isNaN(activeIndex) && pieIndex === activeIndex) ||
    (activeKey && dataKey === activeKey)

  const onMouseOver = () => {
    if (chartId) {
      dispatch(
        setChartData({ chartId, activeKey: dataKey, activeIndex: pieIndex }),
      )
    }
  }
  const onMouseLeave = () => {
    if (chartId) {
      dispatch(
        setChartData({ chartId, activeKey: undefined, activeIndex: undefined }),
      )
    }
  }

  const onChange = () => {
    if (listCheckBox.includes(dataKey)) {
      const newListCheckBox = listCheckBox.filter((item) => item !== dataKey)
      setListCheckBox(newListCheckBox)
    } else {
      const newListCheckBox = [...listCheckBox, dataKey]
      setListCheckBox(newListCheckBox)
    }
  }

  if (hidden || (!listCheckBox.includes(dataKey) && isDynamicReport))
    return <></>

  return (
    <Element
      className="cursorPointer wFitContent"
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      style={{ opacity: isActive ? 1 : 0.4 }}
    >
      {isCheckbox ? (
        <Checkbox
          title={title}
          isI18n={isI18n}
          translateProps={translateProps}
          onChange={onChange}
          style={{ paddingLeft: 6 }}
          styleIcon={{ color, fontSize: 14 }}
          isCheckOnClickText={isCheckOnClickText}
          checked={listCheckBox.includes(dataKey)}
        />
      ) : (
        <Element className="dFlex alignItemsCenter">
          {iconCustom ? (
            <>{renderCustomIcon()}</>
          ) : (
            <Icon className="icon-square" style={{ color, fontSize: 14 }} />
          )}
          <Element
            elementName="span"
            className={`${classes.pl6} ${iconCustom && 'flex1'}`}
          >
            {isEllipsis ? (
              <TextEllipsisStaticLine
                text={title}
                isI18n={isI18n}
                lineClamp={lineClamp}
              />
            ) : isI18n ? (
              <Translate value={title} {...translateProps} />
            ) : (
              title
            )}
          </Element>
        </Element>
      )}
    </Element>
  )
}

LegendItem.propTypes = {
  chartId: PropTypes.string,
  color: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object,
  ]).isRequired,
  isI18n: PropTypes.bool,
  pieIndex: PropTypes.number, // for PieChart
  dataKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // for ComposedChart
  isCheckbox: PropTypes.bool,
  iconCustom: PropTypes.bool,
  hidden: PropTypes.bool,
  isEllipsis: PropTypes.bool,
  lineClamp: PropTypes.number,
  translateProps: PropTypes.object,
  listCheckBox: PropTypes.array,
  renderCustomIcon: PropTypes.func,
  setListCheckBox: PropTypes.func,
  isCheckOnClickText: PropTypes.bool,
  isDynamicReport: PropTypes.bool,
}

LegendItem.defaultProps = {
  isI18n: true,
  isCheckbox: false,
  iconCustom: false,
  hidden: false,
  isEllipsis: false,
  lineClamp: 1,
  translateProps: {},
  listCheckBox: [],
  renderCustomIcon: () => {},
  setListCheckBox: () => {},
  isCheckOnClickText: true,
  isDynamicReport: false,
}
